import api from './api';

export const corporateService = {
  // Get all corporates
  getAllCorporates: async () => {
    const response = await api.get('/corporates');
    return response.data;
  },

  // Create corporate (Chairman only)
  createCorporate: async (data) => {
    const response = await api.post('/corporates', data);
    return response.data;
  },

  // Delete corporate (Chairman only)
  deleteCorporate: async (id) => {
    const response = await api.delete(`/corporates/${id}`);
    return response.data;
  }
};

export default corporateService;
